/**
 *  ? url pada submenu menggunakan naming routes,
 *  ? kelompokkan menu berdasarkan kategori modul agar mudah ditemukan
 */

export default [
  // 1. Master & Referensi Data
  {
    icon: "GridIcon",
    menu: "Fakultas",
    url: "master-fakultas",
    group: "Master & Referensi Data",
  },
  {
    icon: "LayersIcon",
    menu: "Program Studi",
    url: "master-prodi",
    group: "Master & Referensi Data",
  },
  {
    icon: "CalendarIcon",
    menu: "Periode",
    url: "periode",
    group: "Master & Referensi Data",
  },
  {
    icon: "BoxIcon",
    menu: "Ruang Kelas",
    url: "akademik-ruang-kelas",
    group: "Master & Referensi Data",
  },
  {
    icon: "InfoIcon",
    menu: "Info Akademik",
    url: "info-akademik",
    group: "Master & Referensi Data",
  },

  // 2. Civitas (Dosen & Mahasiswa)
  {
    icon: "UsersIcon",
    menu: "Dosen",
    url: "master-dosen",
    group: "Civitas (Dosen & Mahasiswa)",
  },
  {
    icon: "BarChart2Icon",
    menu: "Reporting Dosen",
    url: "akademik-reporting-dosen",
    group: "Civitas (Dosen & Mahasiswa)",
  },
  {
    icon: "UserIcon",
    menu: "Mahasiswa",
    url: "master-mahasiswa",
    group: "Civitas (Dosen & Mahasiswa)",
  },
  {
    icon: "ActivityIcon",
    menu: "Aktivitas Mahasiswa",
    url: "akademik-aktivitas-mahasiswa",
    group: "Civitas (Dosen & Mahasiswa)",
  },

  // 3. Kurikulum & Perkuliahan
  {
    icon: "BookOpenIcon",
    menu: "Kurikulum",
    url: "akademik-kurikulum",
    group: "Kurikulum & Perkuliahan",
  },
  {
    icon: "BookIcon",
    menu: "Mata Kuliah",
    url: "akademik-matakuliah",
    group: "Kurikulum & Perkuliahan",
  },
  {
    icon: "TrendingUpIcon",
    menu: "Rekap Perkuliahan",
    url: "akademik-rekap-perkuliahan",
    group: "Kurikulum & Perkuliahan",
  },

  // 4. KRS, Penilaian & Kelulusan
  {
    icon: "PieChartIcon",
    menu: "Rekap KRS",
    url: "akademik-rekap-krs",
    group: "KRS, Penilaian & Kelulusan",
  },
  {
    icon: "RotateCcwIcon",
    menu: "Restore KRS",
    url: "akademik-restore-krs",
    group: "KRS, Penilaian & Kelulusan",
  },
  {
    icon: "FileTextIcon",
    menu: "Nilai Mahasiswa",
    url: "akademik-nilai",
    group: "KRS, Penilaian & Kelulusan",
  },
  {
    icon: "SlidersIcon",
    menu: "Setting Input Nilai",
    url: "akademik-setting-input-nilai",
    group: "KRS, Penilaian & Kelulusan",
  },
  {
    icon: "AwardIcon",
    menu: "Validasi Ijazah Mahasiswa",
    url: "validasi-ijazah-mahasiswa",
    group: "KRS, Penilaian & Kelulusan",
  },
];
